export const dashboardKeys = {
    all: ['admin-dashboard'] as const,
    kpis: (params: any) => [...dashboardKeys.all, 'kpis', params] as const,
    analytics: (params: any) => [...dashboardKeys.all, 'analytics', params] as const,
    merchants: (params: any) => [...dashboardKeys.all, 'merchants', params] as const,
    transactions: (params: any) => [...dashboardKeys.all, 'transactions', params] as const,
    invoices: (params: any) => [...dashboardKeys.all, 'invoices', params] as const,
    renewals: (params: any) => [...dashboardKeys.all, 'renewals', params] as const,
    ads: (params: any) => [...dashboardKeys.all, 'ads', params] as const,
};
